import React from 'react';
import WarningModalSC from './warning-modal.styled';
import { HeadingTwo } from '../typography';
import { ReactComponent as WarningIcon } from '../../assets/img/svg/Warn-Icon.svg';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import dlt from '../../utils/default-lang';

const WarningModal = ({ headlineText, children }) => {
  return (
    <WarningModalSC>
      <div className="warning-icon-wrap">
        <WarningIcon />
      </div>
      <div className="top-text-wrap">
        {headlineText && (
          <HeadingTwo className="bold orange">
            <FormattedHTMLMessage id={headlineText} defaultMessage={dlt[headlineText]} />
          </HeadingTwo>
        )}
      </div>

      <div className="warning-message-wrap">{children}</div>
    </WarningModalSC>
  );
};

export default injectIntl(WarningModal);
